var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mb-3" },
    [
      _c(
        "custom-callout",
        {
          attrs: {
            "border-color": "#B5C3BC",
            controlled: true,
            "has-toggle": false
          }
        },
        [
          _c("div", { staticClass: "row mt-2" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-sm-12 col-md-2 col-lg-2 py-3 border-right-2 d-flex flex-column align-items-start justify-content-start"
              },
              [
                _c("custom-balloon", {
                  staticClass: "w-100 p-2 mt-2",
                  attrs: {
                    "background-color": _vm.getPeiStatusClass(),
                    text: _vm.value.peiStatusDescription
                  }
                })
              ],
              1
            ),
            _c("div", { staticClass: "col-12 col-lg-8 pt-3 grey-divider" }, [
              _c("div", { class: ["row", { "pt-2": _vm.isMobile }] }, [
                _c("div", { staticClass: "col-lg-2 col-12" }, [
                  _c("div", { staticClass: "info-text-title" }, [
                    _vm._v("Año")
                  ]),
                  _c("p", [_vm._v(" " + _vm._s(_vm.value.academicYear) + " ")])
                ]),
                _c("div", { staticClass: "col-lg-1 col-12" }, [
                  _c("div", { staticClass: "info-text-title" }, [
                    _vm._v("Tipo")
                  ]),
                  _c("p", [_vm._v(" " + _vm._s(_vm.getPeiTypeDesc) + " ")])
                ]),
                _c("div", { staticClass: "col-lg-2 col-12" }, [
                  _c("div", { staticClass: "info-text-title" }, [
                    _vm._v("Número")
                  ]),
                  _c("p", [_vm._v(" " + _vm._s(_vm.parsePeiId) + " ")])
                ]),
                _c("div", { staticClass: "col-lg-2 col-12" }, [
                  _c("div", { staticClass: "info-text-title" }, [
                    _vm._v("Enmienda")
                  ]),
                  _c("p", [
                    _vm._v(" " + _vm._s(_vm.parseGeneralRevisionNo) + " ")
                  ])
                ]),
                _c("div", { staticClass: "col-lg-2 col-12" }, [
                  _c("div", { staticClass: "info-text-title" }, [
                    _vm._v("Fecha Discusión COMPU")
                  ]),
                  _c("p", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("date")(
                            _vm.value.generalClosedDate,
                            "DD/MMM/YYYY"
                          )
                        ) +
                        " "
                    )
                  ])
                ]),
                _c("div", { staticClass: "col-lg-3 col-12" }, [
                  _c("div", { staticClass: "info-text-title" }, [
                    _vm._v("Fecha Inicio de Servicio")
                  ]),
                  _c("p", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("date")(
                            _vm.value.projectedDate.projectedDate,
                            "DD/MMM/YYYY"
                          )
                        ) +
                        " "
                    )
                  ])
                ])
              ])
            ]),
            _c("div", { staticClass: "col-12 col-lg-2 pt-3" }, [
              _c(
                "div",
                {
                  staticClass:
                    "row w-100 custom-button d-flex justify-content-end"
                },
                [
                  _c("DropDown", {
                    key: _vm.value.peiIdFormatted,
                    attrs: { id: "dd-actions", items: _vm.getMenuItems }
                  })
                ],
                1
              )
            ])
          ])
        ]
      ),
      _vm.value.atServiceAmmendment || _vm.value.signedWithoutChecklist
        ? _c("Error", {
            staticClass: "px-3",
            attrs: {
              "can-close": false,
              "is-alert-mode": "",
              "is-borderless": "",
              message:
                "Esta Enmienda de PEI fue generada por proceso de Asistencia Tecnológica"
            },
            on: {
              close: function($event) {
                return _vm.closeErrorPanel()
              }
            }
          })
        : _vm._e(),
      _vm.value.hasCommentFromParentPortal && _vm.showError
        ? _c("Error", {
            attrs: {
              "can-close": "",
              "is-alert-mode": "",
              "is-borderless": "",
              message:
                "El PEI cuenta con un comentario realizado por el padre, madre y/o encargado(o). Favor dirigirse a los comentarios."
            },
            on: {
              close: function($event) {
                return _vm.closeErrorPanel()
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }